import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var MARKER_TYPE = 'application/hydration-marker';
var MARKER_SELECTOR = "[data-type=\"".concat(MARKER_TYPE, "\"]");
var DATA_TYPE = 'application/hydration-data';
var DATA_SELECTOR = "script[type=\"application/hydration-data\"]";

function getComponentName(component) {
  if (!component.displayName) {
    console.warn("`displayName` is missing for component: \"".concat(component.name, "\".\nPartial hydration requires component to have `displayName` property.\n\n") + 'Please follow instructions below: \n' + 'https://github.com/Natural-Intelligence/xsite-ui/tree/master/packages/partial-hydration#why-is-it-important-to-set-displayName-for-hydrated-component\n\n' + 'This would throw an exception in the next major release\n');
  }

  return component.displayName || component.name;
}
function getMarkers(container) {
  var elementCollection = container.querySelectorAll(MARKER_SELECTOR);
  return _toConsumableArray(elementCollection);
}
function getHydrationData() {
  var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  var dataScript = container.querySelectorAll(DATA_SELECTOR);
  var data = {};

  var _iterator = _createForOfIteratorHelper(dataScript),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var el = _step.value;
      data = _objectSpread2(_objectSpread2({}, data), JSON.parse(el.innerHTML));
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return data;
}
function eraseHydrationData() {
  var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  var dataScript = container.querySelectorAll(DATA_SELECTOR);

  var _iterator2 = _createForOfIteratorHelper(dataScript),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var el = _step2.value;
      el.remove();
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
}
function attachHydrationData() {
  var partial = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  var dataScript = partial.querySelectorAll(DATA_SELECTOR);

  if (dataScript !== null && dataScript !== void 0 && dataScript.length) {
    eraseHydrationData();

    var _iterator3 = _createForOfIteratorHelper(dataScript),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var el = _step3.value;
        document.body.append(el);
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }
}
function getComponentMap(components) {
  return new Map(components.map(function (comp) {
    return [getComponentName(comp), comp];
  }));
}
function readMarker(marker) {
  var id = marker.dataset.hid || '';
  var el = marker;
  var parent = el === null || el === void 0 ? void 0 : el.parentElement;
  return {
    id: id,
    el: el,
    parent: parent
  };
}
function getComponent(componentMap, data, id) {
  var _data$id;

  var componentId = data === null || data === void 0 ? void 0 : (_data$id = data[id]) === null || _data$id === void 0 ? void 0 : _data$id.name;
  return componentMap.get(componentId);
}
function getProps(data, id) {
  return data[id] ? data[id].props : {};
}

export { DATA_TYPE as D, MARKER_TYPE as M, _objectSpread2 as _, getMarkers as a, getHydrationData as b, getComponentMap as c, _createForOfIteratorHelper as d, eraseHydrationData as e, getComponent as f, getComponentName as g, getProps as h, attachHydrationData as i, readMarker as r };
